import { render, staticRenderFns } from "./freezeMoney.vue?vue&type=template&id=913b2480&scoped=true"
import script from "./freezeMoney.vue?vue&type=script&lang=js"
export * from "./freezeMoney.vue?vue&type=script&lang=js"
import style0 from "./freezeMoney.vue?vue&type=style&index=0&id=913b2480&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913b2480",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('913b2480')) {
      api.createRecord('913b2480', component.options)
    } else {
      api.reload('913b2480', component.options)
    }
    module.hot.accept("./freezeMoney.vue?vue&type=template&id=913b2480&scoped=true", function () {
      api.rerender('913b2480', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/platformManage/bond/freezeMoney.vue"
export default component.exports